/* eslint-disable */
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@wix/ambassador/runtime/http");
exports.ContactsApp = function (baseUrl, httpClientConfig) {
    var httpClient = new http_1.AmbassadorHTTPClient(baseUrl, httpClientConfig);
    return {
        ContactsService: function () {
            return function (headers) {
                var service = {
                    get: function (v1GetContactRequest) {
                        return httpClient.invoke('GET', '/v1/contacts/{id}', v1GetContactRequest, headers);
                    },
                    list: function (v1ListContactsRequest) {
                        return httpClient.invoke('GET', '/v1/contacts', v1ListContactsRequest, headers);
                    }
                };
                service.get.__http_method = 'GET';
                service.get.__http_url = '/v1/contacts/{id}';
                service.list.__http_method = 'GET';
                service.list.__http_url = '/v1/contacts';
                return service;
            };
        },
        ContactsServiceV4: function () {
            return function (headers) {
                var service = {
                    createContact: function (createContactRequest) {
                        return httpClient.invoke('POST', '/v4/contacts', createContactRequest, headers);
                    },
                    deleteContact: function (deleteContactRequest) {
                        return httpClient.invoke('DELETE', '/v4/contacts/{contact_id}', deleteContactRequest, headers);
                    },
                    findDuplicateContact: function (findDuplicateContactRequest) {
                        return httpClient.invoke('POST', '/v4/contacts/duplicates', findDuplicateContactRequest, headers);
                    },
                    getContact: function (v4GetContactRequest) {
                        return httpClient.invoke('GET', '/v4/contacts/{id}', v4GetContactRequest, headers);
                    },
                    labelContact: function (labelContactRequest) {
                        return httpClient.invoke('POST', '/v4/contacts/{contact_id}/labels', labelContactRequest, headers);
                    },
                    listContacts: function (v4ListContactsRequest) {
                        return httpClient.invoke('GET', '/v4/contacts', v4ListContactsRequest, headers);
                    },
                    listFacets: function (listFacetsRequest) {
                        return httpClient.invoke('GET', '/v4/contacts/facets', listFacetsRequest, headers);
                    },
                    mergeContacts: function (mergeContactsRequest) {
                        return httpClient.invoke('POST', '/v4/contacts/{target_contact_id}/merge', mergeContactsRequest, headers);
                    },
                    previewMergeContacts: function (previewMergeContactsRequest) {
                        return httpClient.invoke('POST', '/v4/contacts/{target_contact_id}/preview-merge', previewMergeContactsRequest, headers);
                    },
                    queryContacts: function (queryContactsRequest) {
                        return httpClient.invoke('POST', '/v4/contacts/query', queryContactsRequest, headers);
                    },
                    unlabelContact: function (unlabelContactRequest) {
                        return httpClient.invoke('DELETE', '/v4/contacts/{contact_id}/labels', unlabelContactRequest, headers);
                    },
                    updateContact: function (updateContactRequest) {
                        return httpClient.invoke('PATCH', '/v4/contacts/{contact_id}', updateContactRequest, headers);
                    }
                };
                service.createContact.__http_method = 'POST';
                service.createContact.__http_url = '/v4/contacts';
                service.deleteContact.__http_method = 'DELETE';
                service.deleteContact.__http_url = '/v4/contacts/{contact_id}';
                service.findDuplicateContact.__http_method = 'POST';
                service.findDuplicateContact.__http_url = '/v4/contacts/duplicates';
                service.getContact.__http_method = 'GET';
                service.getContact.__http_url = '/v4/contacts/{id}';
                service.labelContact.__http_method = 'POST';
                service.labelContact.__http_url = '/v4/contacts/{contact_id}/labels';
                service.listContacts.__http_method = 'GET';
                service.listContacts.__http_url = '/v4/contacts';
                service.listFacets.__http_method = 'GET';
                service.listFacets.__http_url = '/v4/contacts/facets';
                service.mergeContacts.__http_method = 'POST';
                service.mergeContacts.__http_url = '/v4/contacts/{target_contact_id}/merge';
                service.previewMergeContacts.__http_method = 'POST';
                service.previewMergeContacts.__http_url = '/v4/contacts/{target_contact_id}/preview-merge';
                service.queryContacts.__http_method = 'POST';
                service.queryContacts.__http_url = '/v4/contacts/query';
                service.unlabelContact.__http_method = 'DELETE';
                service.unlabelContact.__http_url = '/v4/contacts/{contact_id}/labels';
                service.updateContact.__http_method = 'PATCH';
                service.updateContact.__http_url = '/v4/contacts/{contact_id}';
                return service;
            };
        }
    };
};
exports.ContactsApp.__transport = 'http';
__export(require("./types"));
